export default __webpack_public_path__ + "static/media/ArcadiusWeb@2x.aab03423.jpg";